import * as Sentry from '@sentry/vue';

const SENTRY_INTERESTING_ATTRIBUTES = [
  'href',
  'type',
  'name',
  'id',
  'data-ouia-component-type',
  'data-ouia-component-id',
] as const;

function sentry_element_data(el: HTMLElement) {
  const data: Record<string, string> = {};
  for (const attr of SENTRY_INTERESTING_ATTRIBUTES) {
    const value = el.getAttribute(attr);
    if (value !== null) {
      data[attr] = value;
    }
  }
  return data;
}

export const ignoreErrors = [
  'ResizeObserver loop',
  'Request aborted',
  'Request failed with status code 400',
  'Request failed with status code 401',
  'Request failed with status code 429',
  'Request failed with status code 500',
  'Request failed with status code 503',
  'User denied permission to use the Push API',
  'Network Error',
];

export const beforeBreadcrumb: NonNullable<Parameters<typeof Sentry.init>[0]>['beforeBreadcrumb'] = (breadcrumb, hint) => {
  if (hint?.event instanceof PointerEvent) {
    const target = hint.event.target;
    if (target instanceof HTMLElement) {
      breadcrumb.data ??= {};
      breadcrumb.data.target = sentry_element_data(target);

      const parent = target.parentElement
      if (parent) {
        breadcrumb.data.target.parent = sentry_element_data(parent);
      }
    }
  }

  return breadcrumb;
};
